import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { rankWith, isOneOfControl } from '@jsonforms/core';
import { withJsonFormsOneOfEnumProps } from '@jsonforms/react';
import { useRef, useState } from 'react';
import { t as tradeNameToIdMap, i as iconToComponentMap } from './shared-81439ea7.js';
import { P as PillGroupStyled, T as TradeIconStyled } from './shared-e6e31491.js';
import styled, { css } from 'styled-components';
import { d as descriptionCapsize, h as headingLowerCapsize } from './typography-fe8ea2dd.js';
import { S as SelectBox } from './SelectBox-be5b01c6.js';
import { C as ContextBubble } from './ContextBubble-6223e2a1.js';
import { R as RadioButton } from './RadioButton-8116d351.js';
import { A as Accordion } from './Accordion-9fda376d.js';
import { S as SimpleMarkdown } from './SimpleMarkdown-107c346a.js';

var GAP_SIZE = 18;
var Description = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  margin: 0;\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 0;\n\n  ", "\n"])), descriptionCapsize, function (_a) {
    var theme = _a.theme;
    return "\n    color: " + theme.bottomForegroundPrimary + ";\n  ";
});
var JsonFormsOneOfEnumControlBase = styled.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-row-gap: ", "px;\n  margin: 0;\n  padding: 0;\n\n  ", "\n"], ["\n  display: grid;\n  grid-row-gap: ", "px;\n  margin: 0;\n  padding: 0;\n\n  ", "\n"])), GAP_SIZE, function (_a) {
    var align = _a.align;
    switch (align) {
        case 'center':
            return 'justify-content: center';
        case 'left':
        default:
            return 'margin: 0';
    }
});
var SelectBoxStyled = styled(SelectBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var SelectBoxOneTimeTooltip = styled(ContextBubble)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  left: 20px;\n  top: 136px;\n  width: auto;\n"], ["\n  left: 20px;\n  top: 136px;\n  width: auto;\n"])));
var SubheadLayout = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n  margin: 10px 0 10px 0;\n\n  ", "\n"], ["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n  margin: 10px 0 10px 0;\n\n  ", "\n"])), function (_a) {
    var align = _a.align;
    return align === 'center' ? 'justify-content: center' : null;
});
var Subhead = styled.h2(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n\n  margin: 0;\n  padding: 0;\n  text-align: left;\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 0;\n  padding: 0;\n  text-align: left;\n\n  ", "\n"])), headingLowerCapsize, function (_a) {
    var theme = _a.theme;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.bottomForegroundPrimary);
});
var RadioButtonStyled = styled(RadioButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var nameCounter = 0;
var jsonFormsOneOfEnumControlTester = rankWith(3, isOneOfControl);
/**
 * OneOfEnum Control to be used as a renderer in the `JsonForms` component.
 *
 * @example
 *
 * <JsonForms
 *   renderers={[
 *     {
 *       renderer: JsonFormsOneOfEnumControl,
 *       tester: jsonFormsOneOfEnumControlTester,
 *     },
 *   ]}
 * ></JsonForms>
 */
var JsonFormsOneOfEnumControl = withJsonFormsOneOfEnumProps(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var data = _a.data, enabled = _a.enabled, handleChange = _a.handleChange, label = _a.label, options = _a.options, path = _a.path, uischema = _a.uischema, visible = _a.visible;
    var nameRef = useRef("JsonFormsOneOfEnumControl-" + ++nameCounter);
    var _m = useState(true), isAccordionCollapsed = _m[0], setIsAccordionCollapsed = _m[1];
    /**
     * Injects the a truthy value of state (JsonFormsContext)
     * into the options if it isn't an option
     */
    var title = (_b = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _b === void 0 ? void 0 : _b.title;
    var description = (_c = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _c === void 0 ? void 0 : _c.description;
    var format = (_e = (_d = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _d === void 0 ? void 0 : _d.format) !== null && _e !== void 0 ? _e : 'dropdown';
    var icon = (_f = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _f === void 0 ? void 0 : _f.icon;
    var IconComponent = iconToComponentMap[icon];
    var align = (_g = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _g === void 0 ? void 0 : _g.align;
    var tradeName = (_h = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _h === void 0 ? void 0 : _h.accordionIcon;
    var tradeId = (_k = (_j = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _j === void 0 ? void 0 : _j.tradeId) !== null && _k !== void 0 ? _k : tradeNameToIdMap[tradeName];
    var oneTimeTooltip = (_l = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _l === void 0 ? void 0 : _l.oneTimeTooltip;
    var PillGroupComponent = (jsx(Fragment, { children: jsx(PillGroupStyled, { align: align, onChange: function (event) {
                if (enabled) {
                    handleChange(path, event.currentTarget.value);
                }
            }, options: (options &&
                options.map(function (_a, index) {
                    var optionLabel = _a.label, value = _a.value;
                    // For now, always convert values to strings, even though they
                    //can be a variety of types
                    var optionValueString = "" + value;
                    var indexString = "" + index;
                    return {
                        key: indexString,
                        label: optionLabel,
                        value: optionValueString,
                    };
                })) ||
                [], size: "small", value: data }, void 0) }, void 0));
    if (!visible) {
        return null;
    }
    return (jsxs(JsonFormsOneOfEnumControlBase, __assign({ align: align }, { children: [format === 'accordion' ? (jsx(Fragment, { children: jsx(Accordion, { body: PillGroupComponent, header: jsxs(Fragment, { children: [jsx(TradeIconStyled, { tradeId: tradeId }, void 0), title] }, void 0), isCollapsed: isAccordionCollapsed, onClick: function () {
                        setIsAccordionCollapsed(!isAccordionCollapsed);
                    } }, void 0) }, void 0)) : (jsxs(Fragment, { children: [title && (jsxs(SubheadLayout, __assign({ align: align }, { children: [IconComponent ? jsx(IconComponent, {}, void 0) : null, jsx(Subhead, { children: title }, void 0)] }), void 0)), format === 'dropdown' && (jsxs(Fragment, { children: [jsx(SelectBoxStyled, { defaultLabel: '', disabled: !enabled, inputLabel: label, onChange: function (event) {
                                    handleChange(path, event.currentTarget.value);
                                }, options: (options &&
                                    options.map(function (_a, index) {
                                        var optionLabel = _a.label, value = _a.value;
                                        // For now, always convert values to strings, even though they
                                        // can be a variety of types
                                        var optionValueString = "" + value;
                                        var indexString = "" + index;
                                        return {
                                            key: indexString,
                                            label: optionLabel,
                                            value: optionValueString,
                                        };
                                    })) ||
                                    [], value: data }, void 0), oneTimeTooltip ? (jsx(SelectBoxOneTimeTooltip, __assign({ isEnabled: !data, pointer: {
                                    horizontal: 20,
                                    vertical: 'top',
                                } }, { children: oneTimeTooltip }), void 0)) : null] }, void 0)), format === 'pill' && PillGroupComponent, format === 'radio' &&
                        options &&
                        options.map(function (_a, index) {
                            var optionLabel = _a.label, value = _a.value;
                            var isChecked = false;
                            isChecked = value === data;
                            return (jsx(RadioButtonStyled, __assign({ checked: isChecked, disabled: !enabled, name: nameRef.current, onChange: function (event) {
                                    handleChange(path, event.currentTarget.value);
                                }, value: value }, { children: optionLabel }), index));
                        })] }, void 0)), description && (jsx(Description, { children: jsx(SimpleMarkdown, { children: description }, void 0) }, void 0))] }), void 0));
});

export { JsonFormsOneOfEnumControl as J, jsonFormsOneOfEnumControlTester as j };
